var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('vx-tooltip',{staticClass:"nav-info-icon",attrs:{"text":_vm.text,"position":"right"}},[_c('span',{on:{"click":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('feather-icon',{attrs:{"icon":"InfoIcon","svgClasses":"w-3 h-3"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }